/* ============================================================================
   LAH — PROVADOR POR IA (MetaKosmos / mKFashion)
   Tema: Testes de implementacao (5.0)

   Integracao em modo MANUAL da SDK. Isso e proposital: no modo automatico a
   SDK monta o proprio botao e ADICIONA AO CARRINHO sozinha — o que quebraria
   a Lahtref, porque aqui nenhuma armacao e vendida solta. Ao registrar
   mk.onAddToCart, o controle volta para nos: fechamos o provador e abrimos o
   fluxo de lentes.

   ============================================================================
   A SDK CARREGA SO NO PRIMEIRO CLIQUE
   ============================================================================
   Antes ela vinha no theme.liquid, em toda pagina do site, para todo visitante
   — inclusive quem nunca abre o provador. Traz rastreamento facial, uma das
   coisas mais pesadas que um navegador executa, e a pagina de produto ainda
   carrega um segundo provador (Auglio).

   Agora nada dela existe ate o cliente pedir.

   ============================================================================
   O BOTAO NAO E REESCRITO — corrigido
   ============================================================================
   Uma versao anterior trocava o texto do botao por "abrindo..." durante o
   carregamento. Dois problemas:

     O texto nao deveria aparecer — nao faz parte do desenho do botao.

     E, pior, escrever no textContent APAGA o icone: ele e um elemento filho, e
     substituir o texto do botao remove tudo que estava dentro. Era por isso
     que o icone sumia depois da primeira abertura.

   Agora o estado de carregamento e uma CLASSE. O CSS pode reagir a ela se um
   dia quisermos, mas o conteudo do botao nunca e tocado.

   ============================================================================
   POSICAO NO DESKTOP — restaurada
   ============================================================================
   O botao fica a direita da pilula do Auglio, cuja largura depende do texto
   injetado pelo script deles. Medimos em tempo de execucao. A reescrita
   anterior removeu isso e o botao voltou para o canto.

   O alinhamento mantem as protecoes contra o vazamento de memoria que existia
   aqui: liga UMA VEZ, observa apenas entrada e saida de elementos (nunca
   atributos, que criavam laco com a propria escrita de style) e so escreve
   quando o valor muda.

   ============================================================================
   LIMITE DIARIO DE PROVAS — o botao some e volta no dia seguinte
   (Claude 18.0)
   ============================================================================
   Antes de revelar o botao, perguntamos a mK se o provador esta disponivel
   PARA ESTE PRODUTO E PARA ESTA PESSOA:

     GET https://mkfashion-new-api.mk3dlabs.com/availability/{projeto}/{sku}

   A resposta cobre, numa chamada so: produto liberado, limite de provas da
   pessoa no dia, limite do mes da loja e saldo da conta. Sem autenticacao,
   CORS aberto.

   A chamada SAI DO NAVEGADOR DO CLIENTE de proposito: a mK conta o limite
   por pessoa pelo IP e pelo navegador de quem pergunta. Se saisse de um
   servidor nosso, todo mundo viraria uma pessoa so e, ao estourar, o botao
   sumiria para todos.

   Regra (da propria mK): o botao so aparece com available === true.
   Qualquer outra resposta, erro ou demora (mais de 6s) = botao escondido.
   Motivo mais comum: user_daily_limit_exceeded — a pessoa usou as provas
   do dia; a mK zera a contagem a meia-noite e, na proxima pagina de
   produto, o botao volta sozinho.

   Escondido, nada muda no resto da pagina: o botao nem chega a ser
   revelado (nao ganha is-ready), o body nao ganha lah-mk-ready (no celular
   os outros botoes ficam na arrumacao sem IA) e o "Provar de novo" da foto
   "Sua prova com IA" tambem some. A foto da prova continua: e do cliente.

   COM A PAGINA ABERTA: a cada prova concluida perguntamos de novo. Se essa
   foi a ultima do dia, o botao some ali mesmo, sem recarregar. Nessa
   segunda checagem so uma resposta clara da mK esconde o botao; falha de
   rede nao, para nao sumir com o provador por um tropeco momentaneo.

   Evento no dataLayer quando fica escondido: mk_indisponivel, com o motivo
   em mk_motivo.

   ============================================================================
   AVISO DA ULTIMA PROVA DO DIA (Claude 18.0)
   ============================================================================
   Quando resta UMA prova no dia, o "Provar de novo" da foto "Sua prova com
   IA" (desktop) ganha o aviso "· ultima de hoje". So na ultima, para a
   pessoa escolher bem a cor dessa prova, sem estimular gastar todas.

   De onde vem o "resta uma": a resposta da mK hoje nao diz quantas provas
   sobram. Entao contamos no navegador da pessoa as provas concluidas no dia
   (localStorage, zera a meia-noite do horario do aparelho) e comparamos com
   o limite configurado em Personalizar > Configuracoes do tema > Provador
   por IA (mK) > "Provas por dia". Em 0, o aviso fica desligado. Se um dia
   a resposta da mK trouxer "remaining" (numero), ele passa a valer no
   lugar da contagem. Quem esconde o botao quando acaba continua sendo a mK;
   a contagem so decide o aviso.

   A resposta completa da mK fica em window.__lahMkDisponibilidade, para
   conferir no console da pre-visualizacao.

   NO CELULAR (onde a foto da prova nao aparece): um balao curto "Ultima
   prova de hoje" surge acima do botao de IA, some sozinho em 4s e aparece
   uma vez por produto por dia. Espera o botao estar na tela e o provador
   da mK estar fechado (se a pessoa acabou de fazer a penultima prova, o
   balao aparece quando ela fecha o provador). Evento: mk_ultima_prova_balao.
   ============================================================================ */

(function () {
    'use strict';

    var SDK_URL = 'https://unpkg.com/mk-sdk-git@1/dist/mk-sdk.js';

    var WRAP_SELECTOR = '.lah-mk-btn-wrap';
    var DESKTOP_WRAP_SELECTOR = '.lah-mk-btn-wrap--desktop';
    var AUGLIO_SELECTOR = '.auglio-tryon-btn-product-page';
    var MEDIA_SELECTOR = '.custom-product-medias';
    var LENS_BUTTON_SELECTOR = '.openProductLens';
    var READY_CLASS = 'lah-mk-ready';
    var LOADING_CLASS = 'is-loading';

    var GAP = 8;
    var AUGLIO_WAIT_MS = 6000;
    var AUGLIO_POLL_MS = 120;

    var API_DISPONIBILIDADE = 'https://mkfashion-new-api.mk3dlabs.com/availability/';
    var DISPONIBILIDADE_TIMEOUT_MS = 6000;
    var ORIGEM_MK = /^https:\/\/([a-z0-9-]+\.)*mk3dlabs\.com$/i;
    var INDISPONIVEL_CLASS = 'lah-mk-indisponivel';
    var ULTIMA_CLASS = 'lah-mk-ultima';
    var CONTA_CHAVE = 'lah-mk-provas-dia';
    var BALAO_CHAVE = 'lah-mk-balao';
    var BALAO_TEXTO = 'Última prova de hoje';
    var BALAO_MS = 4000;

    var MODAL_RATIO = 430 / 800;
    var MODAL_MAX_HEIGHT_DESKTOP = 720;

    var carregando = null;
    var preparado = false;
    var alinhamentoLigado = false;

    function getConfig() {
        var el = document.querySelector('[data-lah-mk-config]');
        if (!el) return null;

        return {
            projectId: el.getAttribute('data-mk-project-id') || '',
            identifier: el.getAttribute('data-mk-identifier') || '',
            limite: parseInt(el.getAttribute('data-mk-limite-dia'), 10) || 0,
            ultimaTexto: el.getAttribute('data-mk-ultima-texto') || 'última de hoje'
        };
    }

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function isDesktopViewport() {
        return window.matchMedia('(min-width: 1000px)').matches;
    }

    /* Tamanho do provador em funcao da tela, mantendo a proporcao original
       para o enquadramento do rosto continuar correto. */
    function getModalSize() {
        var vw = window.innerWidth;
        var vh = window.innerHeight;

        var height = isDesktopViewport()
            ? Math.min(MODAL_MAX_HEIGHT_DESKTOP, Math.round(vh * 0.86))
            : Math.round(vh * 0.92);

        var width = Math.round(height * MODAL_RATIO);
        var maxWidth = Math.round(vw * 0.94);

        if (width > maxWidth) {
            width = maxWidth;
            height = Math.round(width / MODAL_RATIO);
        }

        return { width: width, height: height };
    }

    /* =====================================================================
       POSICAO NO DESKTOP
       ===================================================================== */
    function getVisibleAuglio() {
        var auglio = document.querySelector(AUGLIO_SELECTOR);
        if (!auglio) return null;
        if (auglio.offsetParent === null) return null;
        if (!auglio.offsetWidth) return null;
        return auglio;
    }

    function waitForAuglio() {
        return new Promise(function (resolve) {
            var found = getVisibleAuglio();
            if (found) return resolve(found);

            var waited = 0;
            var timer = setInterval(function () {
                var el = getVisibleAuglio();
                if (el) {
                    clearInterval(timer);
                    resolve(el);
                    return;
                }
                waited += AUGLIO_POLL_MS;
                if (waited >= AUGLIO_WAIT_MS) {
                    clearInterval(timer);
                    resolve(null);
                }
            }, AUGLIO_POLL_MS);
        });
    }

    /* So escreve quando o valor muda: reposicionar para o mesmo lugar ainda
       conta como escrita e gera trabalho de layout. */
    function positionDesktopButton() {
        var wrap = document.querySelector(DESKTOP_WRAP_SELECTOR);
        if (!wrap) return;

        var auglio = getVisibleAuglio();

        var left = '15px';
        var top = '15px';

        if (auglio) {
            left = (auglio.offsetLeft + auglio.offsetWidth + GAP) + 'px';
            top = auglio.offsetTop + 'px';
        }

        if (wrap.style.left !== left) wrap.style.left = left;
        if (wrap.style.top !== top) wrap.style.top = top;
    }

    function keepDesktopButtonAligned() {
        if (!isDesktopViewport()) return;
        if (alinhamentoLigado) return;
        alinhamentoLigado = true;

        positionDesktopButton();

        var pendente = false;

        function agendar() {
            if (pendente) return;
            pendente = true;
            requestAnimationFrame(function () {
                pendente = false;
                positionDesktopButton();
            });
        }

        var auglio = getVisibleAuglio();

        if (auglio && window.ResizeObserver) {
            new ResizeObserver(agendar).observe(auglio);
        }

        /* SEM attributes: era o vigia de style que fechava o laco com a propria
           escrita de positionDesktopButton(). */
        var container = document.querySelector(MEDIA_SELECTOR);
        if (container && window.MutationObserver) {
            new MutationObserver(agendar).observe(container, {
                childList: true,
                subtree: true
            });
        }

        window.addEventListener('resize', agendar, { passive: true });
    }

    /* =====================================================================
       DISPONIBILIDADE (limite diario por pessoa, limite do mes, saldo)
       ===================================================================== */

    /* SKU so com caracteres simples vai no caminho; com barra, espaco ou
       outro caractere especial, vai no parametro ?sku= (como pede a mK). */
    function urlDisponibilidade(config) {
        var sku = String(config.identifier);
        var base = API_DISPONIBILIDADE + encodeURIComponent(config.projectId);
        var url = /^[A-Za-z0-9._~-]+$/.test(sku)
            ? base + '/' + sku + '?'
            : base + '?sku=' + encodeURIComponent(sku) + '&';

        /* parametro so para o navegador nunca reaproveitar uma resposta
           antiga guardada em cache */
        return url + '_=' + Date.now();
    }

    /* Responde { ok, motivo, certo }. certo = a mK respondeu de fato (nao foi
       erro de rede nem demora). */
    function consultarDisponibilidade(config) {
        if (!window.fetch) return Promise.resolve({ ok: false, motivo: 'navegador_sem_fetch', certo: false });

        var ctrl = window.AbortController ? new AbortController() : null;
        var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, DISPONIBILIDADE_TIMEOUT_MS) : null;

        return fetch(urlDisponibilidade(config), ctrl ? { signal: ctrl.signal } : undefined)
            .then(function (r) {
                return r.json().catch(function () { return {}; }).then(function (d) {
                    d = d || {};
                    window.__lahMkDisponibilidade = d;
                    if (d.available === true) return { ok: true, motivo: '', certo: true, dados: d };

                    var motivo = d.reason
                        || (d.product && d.product.tryOnEnabled === false ? 'produto_sem_provador' : '')
                        || (r.ok ? 'indisponivel' : 'http_' + r.status);

                    return { ok: false, motivo: String(motivo), certo: r.status < 500, dados: d };
                });
            })
            .catch(function (e) {
                return { ok: false, motivo: e && e.name === 'AbortError' ? 'demorou' : 'erro_de_rede', certo: false };
            })
            .then(function (res) {
                if (timer) clearTimeout(timer);
                return res;
            });
    }

    var avisouIndisponivel = false;

    function esconderProvador(motivo) {
        Array.prototype.forEach.call(document.querySelectorAll(WRAP_SELECTOR), function (wrap) {
            wrap.classList.remove('is-ready');
        });

        document.body.classList.remove(READY_CLASS);
        document.body.classList.remove(ULTIMA_CLASS);
        document.body.classList.add(INDISPONIVEL_CLASS);

        /* "Provar de novo" da foto "Sua prova com IA" some junto */
        if (!document.getElementById('lah-mk-indisponivel-css')) {
            var st = document.createElement('style');
            st.id = 'lah-mk-indisponivel-css';
            st.textContent = 'body.' + INDISPONIVEL_CLASS + ' .lah-mk-btn-wrap, body.' + INDISPONIVEL_CLASS + ' .lah-prova__nova { display: none !important; }';
            document.head.appendChild(st);
        }

        if (!avisouIndisponivel) {
            avisouIndisponivel = true;
            track('mk_indisponivel', { mk_motivo: motivo });
        }
    }

    /* ---------- contagem das provas do dia (so para o aviso da ultima) ---------- */
    function hoje() {
        var d = new Date();
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }

    function provasHoje() {
        try {
            var v = JSON.parse(localStorage.getItem(CONTA_CHAVE) || 'null');
            return v && v.d === hoje() ? (parseInt(v.n, 10) || 0) : 0;
        } catch (e) { return 0; }
    }

    function contarProva() {
        try { localStorage.setItem(CONTA_CHAVE, JSON.stringify({ d: hoje(), n: provasHoje() + 1 })); } catch (e) { /* sem armazenamento: sem aviso */ }
    }

    function restantes(config, dados) {
        if (dados && typeof dados.remaining === 'number') return dados.remaining;
        if (!config.limite) return null;
        return config.limite - provasHoje();
    }

    var avisouUltima = false;

    function aplicarAviso(config, dados) {
        var ultima = restantes(config, dados) === 1 && !document.body.classList.contains(INDISPONIVEL_CLASS);

        if (ultima && !document.getElementById('lah-mk-ultima-css')) {
            var st = document.createElement('style');
            st.id = 'lah-mk-ultima-css';
            st.textContent = 'body.' + ULTIMA_CLASS + ' .lah-prova__nova::after { content: ' + JSON.stringify('· ' + config.ultimaTexto) + '; color: #214132; font-weight: 400; }';
            document.head.appendChild(st);
        }

        document.body.classList.toggle(ULTIMA_CLASS, ultima);

        if (ultima && !avisouUltima) {
            avisouUltima = true;
            track('mk_ultima_prova_aviso', {});
        }

        if (ultima) balaoCelular(config);
    }

    /* ---------- celular: balao acima do botao de IA ---------- */
    function chaveBalao(config) {
        var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
        return m ? decodeURIComponent(m[1]).toLowerCase() : String(config.identifier);
    }

    function balaoJaMostrado(k) {
        try {
            var v = JSON.parse(localStorage.getItem(BALAO_CHAVE) || 'null');
            return !!(v && v.d === hoje() && v.p && v.p.indexOf(k) !== -1);
        } catch (e) { return false; }
    }

    function marcarBalao(k) {
        try {
            var v = JSON.parse(localStorage.getItem(BALAO_CHAVE) || 'null');
            if (!v || v.d !== hoje() || !v.p) v = { d: hoje(), p: [] };
            v.p.push(k);
            v.p = v.p.slice(-40);
            localStorage.setItem(BALAO_CHAVE, JSON.stringify(v));
        } catch (e) { /* sem armazenamento: o balao pode repetir, sem prejuizo */ }
    }

    function provadorAberto() {
        var fs = document.querySelectorAll('iframe[src*="mk3dlabs"]');
        for (var i = 0; i < fs.length; i++) {
            if (fs[i].offsetWidth > 0 && fs[i].offsetHeight > 0) return true;
        }
        return false;
    }

    function naTela(el) {
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }

    function estiloBalao() {
        if (document.getElementById('lah-mk-balao-css')) return;
        var st = document.createElement('style');
        st.id = 'lah-mk-balao-css';
        st.textContent =
            '@media (max-width: 999px) {' +
            '.lah-mk-balao { position: absolute; right: -6px; bottom: calc(100% + 10px); z-index: 6; white-space: nowrap; padding: 8px 12px; border-radius: 999px; background: rgba(255, 255, 255, 0.95); -webkit-backdrop-filter: blur(18px) saturate(1.4); backdrop-filter: blur(18px) saturate(1.4); color: #214132; font: 500 12px/1 Helvetica, Arial, sans-serif; letter-spacing: 0.02em; box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12); opacity: 0; transform: translateY(4px); transition: opacity 0.3s ease, transform 0.3s ease; pointer-events: none; }' +
            '.lah-mk-balao::after { content: ""; position: absolute; right: 21px; bottom: -4px; width: 10px; height: 10px; border-radius: 2px; background: rgba(255, 255, 255, 0.95); transform: rotate(45deg); }' +
            '.lah-mk-balao.is-visivel { opacity: 1; transform: none; }' +
            '}' +
            '@media (prefers-reduced-motion: reduce) { .lah-mk-balao { transition: none; transform: none; } }';
        document.head.appendChild(st);
    }

    var balaoAgendado = false;

    function balaoCelular(config) {
        if (balaoAgendado || isDesktopViewport()) return;
        var k = chaveBalao(config);
        if (balaoJaMostrado(k)) return;
        balaoAgendado = true;

        var tentativas = 0;

        function mostrar(wrap) {
            estiloBalao();
            var b = document.createElement('span');
            b.className = 'lah-mk-balao';
            b.setAttribute('role', 'status');
            b.textContent = BALAO_TEXTO;
            wrap.appendChild(b);
            void b.offsetWidth;
            b.classList.add('is-visivel');
            marcarBalao(k);
            track('mk_ultima_prova_balao', {});

            setTimeout(function () {
                b.classList.remove('is-visivel');
                setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 400);
            }, BALAO_MS);
        }

        /* espera: botao revelado, na tela, e provador da mK fechado */
        (function esperar() {
            if (!document.body.classList.contains(ULTIMA_CLASS) || isDesktopViewport()) { balaoAgendado = false; return; }
            var wrap = document.querySelector('.lah-mk-btn-wrap--mobile.is-ready');
            if (!wrap || provadorAberto() || !naTela(wrap)) {
                if (++tentativas < 600) setTimeout(esperar, 500);
                else balaoAgendado = false;
                return;
            }
            setTimeout(function () {
                if (document.body.classList.contains(ULTIMA_CLASS) && !provadorAberto()) mostrar(wrap);
                else balaoAgendado = false;
            }, 700);
        })();
    }

    /* Com a pagina aberta: a cada prova concluida, pergunta de novo. Se foi
       a ultima do dia, o botao some na hora. So resposta clara da mK
       esconde; tropeco de rede nao. */
    function vigiarProvas(config) {
        var pendente = null;
        var ultimaImagem = null;

        window.addEventListener('message', function (e) {
            if (!ORIGEM_MK.test(e.origin || '')) return;
            var d = e.data;
            if (!d || d.source !== 'mkfashion-app' || d.action !== 'generation_complete') return;

            /* mesmo aviso repetido para a mesma imagem conta uma vez so;
               prova recusada (success: false) nao conta */
            var img = d.data && (d.data.imageUrl || d.data.image || d.data.tryonImage);
            var falhou = d.data && d.data.success === false;
            if (!falhou && (!img || img !== ultimaImagem)) {
                ultimaImagem = img || null;
                contarProva();
            }

            clearTimeout(pendente);
            pendente = setTimeout(function () {
                consultarDisponibilidade(config).then(function (res) {
                    if (!res.ok && res.certo) esconderProvador(res.motivo);
                    else if (res.ok) aplicarAviso(config, res.dados);
                    else aplicarAviso(config, null);
                });
            }, 1500);
        });
    }

    /* =====================================================================
       CARREGAMENTO DA SDK

       Uma promessa so, guardada: cliques repetidos durante o download nao
       baixam a SDK duas vezes.
       ===================================================================== */
    function carregarSdk(config) {
        if (carregando) return carregando;

        carregando = new Promise(function (resolve) {
            if (window.mk && window.mk._isMkSdk) return resolve(window.mk);

            var s = document.createElement('script');
            s.src = SDK_URL;
            s.async = true;
            s.setAttribute('data-mk-project', config.projectId);
            s.setAttribute('data-mk-product', 'mk-fashion');

            /* A SDK se registra em window.mk um instante depois do onload,
               entao esperamos por ela em vez de confiar no evento. */
            var esperou = 0;

            function procurar() {
                if (window.mk && window.mk._isMkSdk) return resolve(window.mk);

                esperou += 120;
                if (esperou >= 10000) return resolve(null);

                setTimeout(procurar, 120);
            }

            s.onload = procurar;
            s.onerror = function () { resolve(null); };

            document.head.appendChild(s);
        });

        return carregando;
    }

    /* Abre o configurador reaproveitando o botao existente da PDP, marcando
       antes a origem para o evento lens_flow_open. */
    function openLensFlow() {
        window.__lahLensSource = 'tryon_mk';

        var lensBtn = document.querySelector(LENS_BUTTON_SELECTOR);
        if (lensBtn) lensBtn.click();
    }

    /* Registrados UMA VEZ, antes da primeira abertura, como pede a doc.
       onAddToCart e o que impede o provador de vender armacao solta. */
    function prepararEventos(mk) {
        if (preparado) return;
        preparado = true;

        mk.onAddToCart(function (payload) {
            track('mk_cart_intercepted', {
                mk_sku: payload && payload.identifier,
                mk_size: payload && payload.size && payload.size.label
            });

            try { mk.close(); } catch (e) { /* ignora */ }

            setTimeout(openLensFlow, 150);
        });

        mk.onInteraction(function (data) {
            track('mk_' + data.category + '_' + data.action, {
                mk_sku: data.sku,
                mk_visitor_id: mk.getVisitorId(),
                mk: data
            });
        });

        mk.onError(function (err) {
            track('mk_error', { mk_message: err && err.message });
        });
    }

    /* =====================================================================
       CLIQUE
       ===================================================================== */
    function ligar() {
        var wraps = document.querySelectorAll(WRAP_SELECTOR);
        if (!wraps.length) return;

        var config = getConfig();
        if (!config || !config.projectId || !config.identifier) return;

        /* No desktop esperamos a pilula do Auglio existir antes de revelar, para
           o botao ja nascer na posicao certa em vez de saltar. Em paralelo,
           a mK diz se o provador esta disponivel para esta pessoa hoje. */
        var pronto = Promise.all([
            consultarDisponibilidade(config),
            isDesktopViewport() ? waitForAuglio() : Promise.resolve(null)
        ]);

        vigiarProvas(config);

        pronto.then(function (res) {
            var disp = res[0];

            if (!disp.ok) {
                esconderProvador(disp.motivo);
                return;
            }

            aplicarAviso(config, disp.dados);
            positionDesktopButton();

            requestAnimationFrame(function () {
                /* uma prova concluida durante a espera pode ter esgotado o dia */
                if (document.body.classList.contains(INDISPONIVEL_CLASS)) return;

                Array.prototype.forEach.call(wraps, function (wrap) {
                    wrap.classList.add('is-ready');
                });

                document.body.classList.add(READY_CLASS);

                keepDesktopButtonAligned();
            });
        });

        Array.prototype.forEach.call(wraps, function (wrap) {
            var btn = wrap.querySelector('.lah-mk-btn');
            if (!btn) return;

            btn.addEventListener('click', function () {
                if (btn.classList.contains(LOADING_CLASS)) return;
                if (document.body.classList.contains(INDISPONIVEL_CLASS)) return;

                track('mk_open_click', { mk_sku: config.identifier });

                /* Classe, nunca texto: escrever no botao apagaria o icone. */
                btn.classList.add(LOADING_CLASS);

                function devolver() {
                    btn.classList.remove(LOADING_CLASS);
                }

                carregarSdk(config).then(function (mk) {
                    if (!mk) {
                        devolver();
                        track('mk_error', { mk_message: 'sdk_nao_carregou' });
                        return;
                    }

                    prepararEventos(mk);

                    return mk.isAvailable(config.projectId, config.identifier)
                        .then(function (available) {
                            devolver();

                            if (!available) {
                                track('mk_error', { mk_message: 'modelo_sem_provador' });
                                return;
                            }

                            var size = getModalSize();

                            mk.open({
                                projectId: config.projectId,
                                identifier: config.identifier,
                                width: size.width,
                                height: size.height
                            });
                        });
                }).catch(function () {
                    devolver();
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', ligar);
    } else {
        ligar();
    }
})();

/* ============================================================================
   LAH — "VOCE NA PAGINA": A ULTIMA PROVA POR IA COMO 2a FOTO (Claude 17.0)

   Quando o provador da MetaKosmos termina uma prova, o iframe deles avisa a
   pagina (postMessage 'mkfashion-app' / 'generation_complete') com a imagem
   gerada. Guardamos essa imagem NO NAVEGADOR DO PROPRIO CLIENTE (IndexedDB),
   uma por produto: nova prova do mesmo produto substitui a anterior. Nada vai
   para servidor nosso.

   No DESKTOP a prova aparece como a 2a foto da faixa (ou da grade antiga),
   com o selo "Sua prova com IA", um botao "Provar de novo" e um x para o
   cliente apagar a foto dele. No celular a prova e guardada, mas nao aparece.

   SEGURANCA: so aceitamos o aviso vindo do dominio da MetaKosmos
   (*.mk3dlabs.com) e so imagens (data:image/... ou https). A imagem entra
   apenas como src de <img>; nunca como HTML.

   ENCAIXE NA FAIXA SEM MEXER NA FAIXA: o item e um <div> nosso dentro da
   faixa, com order 0. As fotos do Alpine tem order = posicao (0, 1, 2...);
   empatado com a 1a foto e vindo depois dela no HTML, ele fica em 2o. Se o
   Alpine redesenhar a faixa (troca de cor, editor), um observador recoloca.
   Fica fora do zoom de fotos de produto (nao tem a classe image-high).
   ============================================================================ */
(function () {
    'use strict';

    if (window.__lahMkProva) return;
    window.__lahMkProva = true;

    var ORIGEM_MK = /^https:\/\/([a-z0-9-]+\.)*mk3dlabs\.com$/i;
    var IMG_OK = /^(data:image\/(png|jpe?g|webp|avif);base64,|https:\/\/)/i;
    var FAIXA = '.custom-product-images-highlight';
    var MEDIAS = '.custom-product-medias';
    var DB_NOME = 'lah-mk';
    var DB_LOJA = 'provas';
    var MAX_PRODUTOS = 12;

    var prova = null;      /* { url, objUrl, t } da prova deste produto */
    var nova = false;      /* acabou de ser gerada nesta visita */
    var agendado = false;

    function track(evento, dados) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: evento }, dados || {}));
        } catch (e) { /* analytics nunca quebra a pagina */ }
    }

    function chaveProduto() {
        var m = (location.pathname || '').match(/\/products\/([^\/?#]+)/);
        if (m) return 'p:' + decodeURIComponent(m[1]).toLowerCase();
        var cfg = document.querySelector('[data-lah-mk-config]');
        return cfg ? 'sku:' + (cfg.getAttribute('data-mk-identifier') || '') : null;
    }

    var CHAVE = chaveProduto();
    if (!CHAVE) return;

    /* ---------------- armazenamento (IndexedDB) ---------------- */
    var dbP = null;

    function db() {
        if (dbP) return dbP;
        dbP = new Promise(function (ok, falha) {
            if (!window.indexedDB) return falha(new Error('sem indexedDB'));
            var r = indexedDB.open(DB_NOME, 1);
            r.onupgradeneeded = function () {
                if (!r.result.objectStoreNames.contains(DB_LOJA)) r.result.createObjectStore(DB_LOJA);
            };
            r.onsuccess = function () { ok(r.result); };
            r.onerror = function () { falha(r.error); };
        });
        return dbP;
    }

    function op(modo, fn) {
        return db().then(function (d) {
            return new Promise(function (ok, falha) {
                var tx = d.transaction(DB_LOJA, modo);
                var res = fn(tx.objectStore(DB_LOJA));
                tx.oncomplete = function () { ok(res && 'result' in res ? res.result : undefined); };
                tx.onerror = function () { falha(tx.error); };
                tx.onabort = function () { falha(tx.error); };
            });
        });
    }

    function ler() {
        return op('readonly', function (s) { return s.get(CHAVE); });
    }

    function gravar(reg) {
        return op('readwrite', function (s) { s.put(reg, CHAVE); }).then(limparAntigas);
    }

    function apagar() {
        return op('readwrite', function (s) { s.delete(CHAVE); });
    }

    /* guarda so as provas dos MAX_PRODUTOS produtos mais recentes */
    function limparAntigas() {
        return op('readwrite', function (s) {
            var r = s.openCursor();
            var itens = [];
            r.onsuccess = function () {
                var c = r.result;
                if (c) { itens.push({ k: c.key, t: (c.value && c.value.t) || 0 }); c.continue(); return; }
                itens.sort(function (a, b) { return b.t - a.t; });
                itens.slice(MAX_PRODUTOS).forEach(function (it) { s.delete(it.k); });
            };
        });
    }

    function dataUrlParaBlob(u) {
        var m = u.match(/^data:([^;,]+);base64,(.*)$/);
        if (!m) return null;
        var bin = atob(m[2]);
        var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        return new Blob([arr], { type: m[1] });
    }

    function definir(reg) {
        if (prova && prova.objUrl) { try { URL.revokeObjectURL(prova.objUrl); } catch (e) {} }
        prova = null;
        if (!reg) return;
        if (reg.blob) {
            var o = URL.createObjectURL(reg.blob);
            prova = { url: o, objUrl: o, t: reg.t };
        } else if (reg.url && IMG_OK.test(reg.url)) {
            prova = { url: reg.url, t: reg.t };
        }
    }

    /* ---------------- captura do aviso do provador ---------------- */
    function receber(payload) {
        if (!payload || payload.success === false) return;
        var url = payload.imageUrl || payload.image || payload.tryonImage;
        if (typeof url !== 'string' || !IMG_OK.test(url)) return;

        var reg = { t: Date.now() };
        if (url.indexOf('data:') === 0) {
            try { reg.blob = dataUrlParaBlob(url); } catch (e) { reg.blob = null; }
            if (!reg.blob) return;
        } else {
            reg.url = url;
        }

        definir(reg);
        nova = true;
        agendar();
        track('mk_prova_salva', { prova_origem: reg.blob ? 'arquivo' : 'link' });

        gravar(reg).catch(function () { /* sem IndexedDB: vale so nesta visita */ });
    }

    window.addEventListener('message', function (e) {
        if (!ORIGEM_MK.test(e.origin || '')) return;
        var d = e.data;
        if (!d || d.source !== 'mkfashion-app' || d.action !== 'generation_complete') return;
        receber(d.data || {});
    });

    /* ---------------- exibicao (so desktop) ---------------- */
    var ICO_IA = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.6c.26 0 .49.17.57.42l1.16 3.66a4.6 4.6 0 0 0 2.93 2.93l3.66 1.16a.6.6 0 0 1 0 1.14l-3.66 1.16a4.6 4.6 0 0 0-2.93 2.93l-1.16 3.66a.6.6 0 0 1-1.14 0l-1.16-3.66a4.6 4.6 0 0 0-2.93-2.93L3.68 12.5a.6.6 0 0 1 0-1.14l3.66-1.16a4.6 4.6 0 0 0 2.93-2.93l1.16-3.66a.6.6 0 0 1 .57-.42Z"/></svg>';
    var ICO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    function estilos() {
        if (document.getElementById('lah-prova-css')) return;
        var st = document.createElement('style');
        st.id = 'lah-prova-css';
        st.textContent =
            '@media (min-width: 1000px) {' +
            '.custom-product-images-highlight > .lah-prova { position: relative; overflow: hidden; border-radius: var(--faixa-raio, 10px); aspect-ratio: var(--faixa-ar, 0.788); background: #ECEBE7; }' +
            '.custom-main-product:not(.custom-main-product--faixa) .custom-product-images-highlight > .lah-prova { width: 100%; }' +
            '.custom-product-images-highlight:not(:has(> img.image-high:not([style*="display: none"]))) > .lah-prova { display: none; }' +
            '.lah-prova__img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: 50% 30%; -webkit-user-drag: none; user-select: none; }' +
            '.lah-prova.is-nova .lah-prova__img { animation: lahProvaEntra 0.7s ease both; }' +
            '@keyframes lahProvaEntra { from { opacity: 0; transform: scale(1.03); } to { opacity: 1; transform: none; } }' +
            '.lah-prova__selo, .lah-prova__nova, .lah-prova__x { position: absolute; z-index: 2; display: inline-flex; align-items: center; gap: 6px; border: 0; border-radius: 999px; background: rgba(255, 255, 255, 0.92); -webkit-backdrop-filter: blur(18px) saturate(1.4); backdrop-filter: blur(18px) saturate(1.4); color: #214132; font: 500 12px/1 Helvetica, Arial, sans-serif; letter-spacing: 0.02em; box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10); }' +
            '.lah-prova__selo { left: 14px; bottom: 14px; height: 32px; padding: 0 12px; pointer-events: none; }' +
            '.lah-prova__selo svg { width: 14px; height: 14px; }' +
            '.lah-prova__nova { right: 14px; bottom: 14px; height: 32px; padding: 0 14px; cursor: pointer; color: #111111; }' +
            '.lah-prova__nova:hover, .lah-prova__x:hover { background: #FFFFFF; }' +
            '.lah-prova__x { top: 14px; right: 14px; width: 32px; height: 32px; justify-content: center; padding: 0; cursor: pointer; color: #111111; opacity: 0; transition: opacity 0.2s ease; }' +
            '.lah-prova:hover .lah-prova__x, .lah-prova__x:focus-visible { opacity: 1; }' +
            '.lah-prova__x svg { width: 14px; height: 14px; }' +
            '}';
        document.head.appendChild(st);
    }

    function nomeProduto() {
        var h = document.querySelector('.custom-product-title');
        return h ? h.textContent.trim() : '';
    }

    function montar() {
        var el = document.createElement('div');
        el.className = 'lah-prova';
        el.setAttribute('data-lah-prova', '');
        el.style.order = '0';

        var img = document.createElement('img');
        img.className = 'lah-prova__img';
        img.alt = 'Sua prova virtual' + (nomeProduto() ? ' com o ' + nomeProduto() : '');
        img.decoding = 'async';
        img.draggable = false;
        img.addEventListener('error', function () {
            /* link que expirou: some e limpa */
            remover(false);
        });
        el.appendChild(img);

        var selo = document.createElement('span');
        selo.className = 'lah-prova__selo';
        selo.innerHTML = ICO_IA + '<span>Sua prova com IA</span>';
        el.appendChild(selo);

        var de = document.createElement('button');
        de.type = 'button';
        de.className = 'lah-prova__nova';
        de.textContent = 'Provar de novo';
        de.addEventListener('click', function () {
            track('mk_prova_refazer', {});
            var b = document.querySelector('.lah-mk-btn-wrap--desktop .lah-mk-btn') || document.querySelector('.lah-mk-btn');
            if (b) b.click();
        });
        el.appendChild(de);

        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'lah-prova__x';
        x.setAttribute('aria-label', 'Remover minha prova desta página');
        x.innerHTML = ICO_X;
        x.addEventListener('click', function () { remover(true); });
        el.appendChild(x);

        return el;
    }

    function remover(peloCliente) {
        definir(null);
        nova = false;
        Array.prototype.forEach.call(document.querySelectorAll('[data-lah-prova]'), function (n) { n.remove(); });
        medir();
        apagar().catch(function () {});
        if (peloCliente) track('mk_prova_removida', {});
    }

    function medir() {
        if (window.__lahFaixaMedir) { try { window.__lahFaixaMedir(); } catch (e) {} }
    }

    /* traz a prova para dentro da faixa visivel (rolagem horizontal) */
    function mostrarNaFaixa(f, el) {
        var fr = f.getBoundingClientRect();
        var er = el.getBoundingClientRect();
        if (er.left >= fr.left && er.right <= fr.right) return;
        var alvo = f.scrollLeft + (er.left - fr.left) - 24;
        try { f.scrollTo({ left: Math.max(0, alvo), behavior: 'smooth' }); } catch (e) { f.scrollLeft = Math.max(0, alvo); }
    }

    var exibida = false;

    function garantir() {
        agendado = false;
        var f = document.querySelector(FAIXA);
        var atual = f ? f.querySelector(':scope > [data-lah-prova]') : null;

        if (!f || !prova) {
            if (atual) { atual.remove(); medir(); }
            return;
        }

        estilos();

        if (!atual) atual = montar();
        var img = atual.querySelector('.lah-prova__img');
        if (img.getAttribute('src') !== prova.url) img.setAttribute('src', prova.url);

        /* ultimo filho: assim, empatado em order 0 com a 1a foto, fica em 2o */
        if (atual.parentNode !== f || f.lastElementChild !== atual) {
            f.appendChild(atual);
            medir();
        }

        if (!exibida) {
            exibida = true;
            track('mk_prova_exibida', { prova_nova: nova });
        }

        if (nova) {
            nova = false;
            atual.classList.remove('is-nova');
            void atual.offsetWidth;
            atual.classList.add('is-nova');
            setTimeout(function () { mostrarNaFaixa(f, atual); }, 400);
        }
    }

    function agendar() {
        if (agendado) return;
        agendado = true;
        requestAnimationFrame(garantir);
    }

    function iniciar() {
        ler().then(function (reg) {
            if (reg && !prova) { definir(reg); agendar(); }
        }).catch(function () {});

        /* a faixa nasce e renasce com o Alpine (desktop, troca de cor, editor) */
        var alvo = document.querySelector(MEDIAS) || document.body;
        if (window.MutationObserver) {
            new MutationObserver(agendar).observe(alvo, { childList: true, subtree: true });
        }
        window.addEventListener('resize', agendar, { passive: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }
})();
